import { ReceiptsEventType } from './../receipts.event.type';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import { Router } from '@angular/router';

@Component({
	selector: 'app-month-filter',
	templateUrl: './month-filter.component.html',
	styleUrls: ['./month-filter.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class MonthFilterComponent implements OnInit {

	slideConfig = {
		slidesToShow : 8,
		slidesToScroll: 1,
		initialSlide: 4,
		arrows: true,
		dots: false,
		infinite: false,
		prevArrow : '<button type="button" class="slick-prev material-icons arrow"><span>&#xE5C5;</span></button>',
		nextArrow : '<button type="button" class="slick-next material-icons arrow"><span>&#xE5C5;</span></button>',
		draggable: false
	};


	months = Array<object>();
	monthsAll = Array<object>();
	monthId: number;

	constructor(private router: Router) {

		moment.locale('pt-br');
		const monthsNames = moment.monthsShort();

		let i = 0;
		for (const name of monthsNames) {
			i++;
			this.monthsAll.push({name});
		}

		this.setMonths();
	}

	setMonths() {
		const today = new Date();
		let actualDate;
		let monthNum;
		let monthText;
		let year;
		for (let i = 12; i > 0; i -= 1) {
			actualDate = new Date(today.getFullYear(), today.getMonth() + 1 - i, 1);
			monthNum = ('0' + (actualDate.getMonth() + 1)).slice(-2);
			monthText = this.monthsAll[actualDate.getMonth()];
			year = actualDate.getFullYear();
			this.months.push({ monthText, month: monthNum, year: year });
		}
	}

	markButton(e) {
		$('.btn-filter-month').removeClass('active');
		$('.filter-item').removeClass('active');

		e.currentTarget.classList.add('active');
	}

	ngOnInit() { }

	loadByMonth(month) {
		const dateBegin = new Date(month.year + '-' + month.month + '-' + '01');
		const dateEnd = new Date(month.year + '-' + month.month + '-' + moment(month.year + '-' + month.month, 'YYYY-MM').daysInMonth());
		AppEventDispatcher.dispatch(ReceiptsEventType.UPDATE, {dateBegin: dateBegin, dateEnd: dateEnd});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/month-filter/month-filter.component.ts